import { useQuery } from '@tanstack/react-query'
import { fetchCarePlanById } from '../services/care_plan';

const GetCarePlanById = (carePlanId) => {
 const carePlan = useQuery({
    queryKey:['care_plan_by_id', carePlanId],
    queryFn: () => fetchCarePlanById(carePlanId),
    enabled: !!carePlanId
 })
 return carePlan;
}

export default GetCarePlanById 